<script setup>
</script>

<template>
  <div class="about">
    <div class="about-content">
      <img src="../assets/devimage.jpg" alt="Dev image" class="about-image">
      <div class="about-text">
        <h2>Hello, My name is Karl.</h2>
        <p>I am a Full Stack Developer who is passionate about building Websites and Applications.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.about {
  background-color: #fff; /* Change background to white */
  color: #2c3e50; /* Set text color */
  padding: 20px; /* Increased padding for better spacing */
}

.about-content {
  display: flex; /* Use flexbox to align items side by side */
  align-items: center; /* Align items vertically */
  flex-direction: column;
}

.about-image {
  width: 200px; /* Adjust image width to make it bigger */
  height: auto; /* Maintain aspect ratio */
  margin-right: 10px; /* Reduce margin to bring the image closer to the text */
}

.about-text {
  flex: 1; /* Fill remaining space in the flex container */
}

.about-text h2 {
  font-size: 24px; /* Larger font size for the heading */
  margin-bottom: 10px; /* Add margin below the heading */
  color: #007bff; /* Set heading color to a cool blue */
}

.about-text p {
  font-size: 16px; /* Adjust font size for paragraph */
  line-height: 1.5; /* Increase line height for better readability */
}
</style>
